export default __webpack_public_path__ + "static/media/QuadraticEquationImg.c9c21a9c.jpg";